import { appPlatforms, commonStatus, currencyTypes, productAttributeInputTypes, statusTypes } from '.';

export const statusDDL = [
    { value: commonStatus.ACTIVE, label: 'Active' },
    { value: commonStatus.LOCK, label: 'Lock' }
]

export const productAttributeInputTypesDDL = [
    { value: productAttributeInputTypes.DROPDOWN, label: 'Dropdown' },
    // { value: productAttributeInputTypes.MULTISELECT, label: 'MultiSelect' },
    { value: productAttributeInputTypes.PLAIN_TEXT, label: 'PlainText' },
    // { value: productAttributeInputTypes.RICH_TEXT, label: 'RichText' }
]

export const currencyOptions = [
    { value: currencyTypes.VND, label: 'VNĐ' },
]

export const smsTransactionStatuses = [
    {value: statusTypes.SUBMITTED, label: 'Submitted'},
    {value: statusTypes.SUBMIT_FAILED, label: 'Submit Failed'},
    {value: statusTypes.SENT, label: 'Sent'},
    {value: statusTypes.SEND_FAILED, label: 'Send Failed'},
]

export const appPlatformDDL = [
    { value: appPlatforms.EDUFUN, label: 'Edufun' },
]